import { TransportClass } from '../../../shared/types/transport';
import { api } from '../index';

export const getTransportClasses = async (
  transportPricingId?: number,
) => {
  const response = await api.get('/transport/classes', {
    params: transportPricingId ? { transportPricingId } : {},
  });
  return response?.data;
};

export const updateTransportClass = async (
  updatedClass: TransportClass,
) => {
  const response = await api.put(
    `/transport/classes/${updatedClass.id}`,
    updatedClass,
  );
  return response.data;
};

export const createTransportClass = async (
  newClass: Omit<TransportClass, 'id'>,
) => {
  const response = await api.post('/transport/classes', newClass);
  return response.data;
};

export const deleteTransportClass = async (id: number) => {
  const response = await api.delete(`/transport/classes/${id}`);
  return response.data;
};
